// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Major/Detail/index.less
// module id = 897
// module chunks = 0